$(document).ready(function () {

	// owl buttons
	$('.prev').click(function(){
		$('.owl-carousel').trigger('prev.owl.carousel');
	});
	$('.next').click(function(){
		$('.owl-carousel').trigger('next.owl.carousel');
	});
	$('.owl-carousel').owlCarousel({
		// smartSpeed: 300
	});

    if (window.matchMedia("(max-width: 900px)").matches) {
        $('.indx-feat').owlCarousel({
            dots:true,
            nav:true,
            items:2,
             navText : ["",""],
             responsive:{
                  0:{
                      items:1
                  },
                  440:{
                      items:2,
                  },
                   640:{
                      items:3
                  },
             
      
             }
          });
    }
    else{
        $('.indx-feat').owlCarousel('destroy');
    }

	/**
	 * Вкладки
	 */
	var tabs = function (params) {
		var def = {
			el: '.js-tab',
			linkClass: '.js-tab-link',
			contentClass: '.js-tab-content',
			removeLinkActiveBefore: true,//Если нужно оставить активными предыдущие ссылки
			divided: false,//Если навигация и контент находятся в разных блоках
			linkClick: undefined,
			disableSize: 0,//отключить на разрешении

		}
		var data = def;
		var isInited = false;
		$.extend(data, def, params);

		var $this = $(data.el).eq(0);
		var links = $this.find(data.linkClass);
		var content = $this.find(data.contentClass);
		if (data.divided === true) {
			$this = $(data.el).eq(0);
			links = $(data.linkClass);
			content = $(data.contentClass);
		}


		function init() {
			links.removeClass('is-active');
			links.eq(0).addClass('is-active');
			content.css('display', 'none')
			content.removeClass('is-active');
			content.eq(0).addClass('is-active');
			content.eq(0).css('display', 'block');
			console.log('inited');
			links.on('click', clickLink);
			isInited = true;
		}
		function setActive(id) {
			links.removeClass('is-active');
			if (data.removeLinkActiveBefore == false) {
				for (var i = 0; i < id; i++) {
					links.eq(i).addClass('is-active')
				}
			}

			links.eq(id).addClass('is-active');
			content.fadeOut();
			content.removeClass('is-active');
			content.eq(id).addClass('is-active');
			content.eq(id).fadeIn();
		}
		function next() {
			for (var i = 0; i < links.length; i++) {
				if (links.eq(i).hasClass('is-active')) {
					var id = links.index(links[i + 1]);
					setActive(id);
					break;
				}
			}
		}
		function hideAllContent() {
			content.fadeOut();
			content.removeClass('is-active');
		}
		function showActive() {
			for (var i = 0; i < links.length; i++) {
				if (links.eq(i).hasClass('is-active')) {
					var id = links.index(links[i]);

					setActive(id);
					break;
				}
			}
		}
		function disable() {
			links.off('click', clickLink);
			content.removeClass('is-active');
			content.attr('style', '');
			links.removeClass('is-active');
			isInited = false;
			console.log('Disabled');
		}
		function resize() {
			if (data.disableSize >= window.innerWidth) {
				if (isInited === true) {
					disable();
				}
			}
			else {
				if (isInited === false) {
					init();
				}
			}
		}
		function clickLink(e) {
			e.preventDefault();
			var id = links.index(this);
			setActive(id);
			if (data.linkClick !== undefined) {
				data.linkClick(data);
			}
		}
		resize();
		$(window).resize(function () { resize() });
		return {
			el: $this,//базовый элемент
			links: links,//список ссылок
			content: content,//список вкладок
			setActive: setActive,//установить активный
			next: next,//Следующий
			hideAllContent: hideAllContent,//Скрыть контент
			showActive: showActive,//Открыть активный
			disable: disable//отключить

		}
	};
	/**/


	var Accord = function (el, params) {
		console.log(params.link)
		var $this = $(el);
		var isInited = false;
		var def = {
			link: '.js-accord-btn',
			content: '.js-accrod-content',
			enableSize: -1,
		}
		var data = {};
		$.extend(data, def, params);
		var title = $this.find(data.link);
		var content = $this.find(data.content);
		function init() {
			title.on('click', click);
			content.css({
				'display':'none'
			})
			isInited = true;
		}
		function disable() {
			title.off('click', click);
			content.attr('style','');
			isInited = false;
		}
		function click() {
			$this.toggleClass('is-active');
			content.slideToggle();
		}
		function resize() {
			if(data.enableSize==-1&&isInited===false){
				init();
				return true;
			}
			if (data.enableSize >= window.innerWidth) {
				if (isInited === false) {
					init();
				}
			}
			else {

				if (isInited === true) {
					disable();
				}
			}
		}
		resize();
		$(window).resize(function () { resize() });
		return {
			close: close,

		}
	};






	var global_nav = tabs({
		el: '.account-nav',
		linkClass: '.account-nav__item',
		contentClass: '.account-content',
		divided: true,
		disableSize: 870
	});


	var stages = tabs({
		el: '.tab-stages',
		linkClass: '.tab-stages__nav .item',
		contentClass: '.tab-stages__content',
		disableSize: 470
	});

	var city_repres = [];
	$('.city-repres.city-repres--glob').each(function () {
		city_repres.push(tabs({
			el: $(this),
			linkClass: '.cir-stages__item',
			removeLinkActiveBefore: false,
			contentClass: '.stages-cont',
		}));
	})


	$('.stages-cont--anketa .stages-cont__btn').on('click', function (e) {
		e.preventDefault();
		for (var i = 0; i < city_repres.length; i++) {
			console.log($(this).parents('.city-repres'));
			if (($(this).parents('.city-repres')[0]).isEqualNode(city_repres[i].el[0])) {
				/*
				* Проверка
				*/
				city_repres[i].next();
			}
		}
	});






	/*/*/
	var Quiz = function (params) {
		var def = {
			el: '.quiz',
			block: '.quiz__block',
			nextBtn: '.quiz__next',
			nextClassDisabled: 'quiz__next--disabled',
			positionBlock: '.quiz__position',
			lengthBlock: '.quiz__length',
			isEndCallBack: undefined,
		}
		var data = $.extend(data, def, params);
		var $this = $(data.el);
		var content = $this.find(data.block);
		var positionBlock = $this.find(data.positionBlock);
		var lengthBlock = $this.find(data.lengthBlock);
		lengthBlock.html(content.length);

		$this.find(data.nextBtn).each(function () {
			$(this).addClass(data.nextClassDisabled);
		});
		var blocks = [];
		function setActive(id) {

			var next = content.eq(id);

			content.css({
				'display': 'none'
			});
			content.removeClass('is-active');
			if (next.length != 0) {
				positionBlock.html(id + 1);
				next.addClass('is-active');
				next.fadeIn();
				return true;
			}
			if (data.isEndCallBack !== undefined || typeof (data.isEndCallBack) === "function") {
				data.isEndCallBack(data);
				return false;
			}

		}
		for (var i = 0; i < content.length; i++) {
			blocks.push({
				content: content.eq(i),
				nextBtn: content.eq(i).find(data.nextBtn),
			});
		}

		for (var i = 0; i < blocks.length; i++) {
			blocks[i].nextBtn.on('click', function (e) {
				e.preventDefault();
				var cont_this = $(this).parents(data.block);
				var id = content.index(cont_this);
				var inp = content.eq(id).find('input');

				for (var j = 0; j < inp.length; j++) {

					if (inp.eq(j)[0].checked == true) {
						setActive(id + 1)
						break;
					}
				}

			});
		}
		setActive(0);
		return {
			el: $this,
			setActive: setActive
		}
	}
	var quiz = undefined;

	var quizCityRepres = tabs({
		el: $('.city-repres--quiz'),
		linkClass: '.cir-stages__item',
		removeLinkActiveBefore: false,
		contentClass: '.stages-cont',
		linkClick: function (data) {
			quiz.el.css('display', 'none');
		}
	})
	/**/
	quiz = Quiz({
		el: '.quiz',
		block: '.quiz__block',
		nextBtn: '.quiz__next',
		nextClassDisabled: 'quiz__next--disabled',
		isEndCallBack: function (data) {
			console.log("The end");
			quizCityRepres.next();
			$(data.el).css('display', 'none');
		}
	})




	/**
	 *  открыть тест
	*/
	$('.stages-cont--test').on('click', function (e) {
		e.preventDefault();
		/*
			проверка не пройден ли он уже
		*/
		quizCityRepres.hideAllContent();
		quiz.el.css({
			'display': 'block'
		});
		quiz.setActive(0);
	});

	$('.get-gift .r-btn').on('click', function () {
		stages.setActive(1);
		for (var i = 0; i < city_repres.length; i++) {
			city_repres[i].setActive(0);
		}
	});

	/********************/
	$('.b-progrees').each(function () {
		var val = parseInt($(this).attr('data-val'));
		var max = parseInt($(this).attr('data-max'));

		$(this).find('.b-progrees__val').css({
			'width': (val * 100 / max) + '%'
		})
	});






	/*** Выбор файла Drag-drop */
	!function () {
		if ($('.file-upload ').length == 0) {
			return false;
		}
		['dragenter', 'dragover'].forEach((ename) => {
			$('.file-upload ')[0].addEventListener(ename, function (e) {
				e.preventDefault();
				//console.log(e);
				this.classList.add('file-upload--draging')
				e.stopPropagation();
			})
		});
		['dragleave', 'drop'].forEach((ename) => {
			$('.file-upload ')[0].addEventListener(ename, function (e) {
				e.preventDefault();
				this.classList.remove('file-upload--draging')
				e.stopPropagation();
			})
		});
		$('.file-upload ')[0].addEventListener('drop', function (e) {
			try {
				let dt = e.dataTransfer;
				let files = dt.files;
				filesAppend(files);
				e.preventDefault();
				e.stopPropagation();
			}
			catch (Er) {
				console.error(Er);
				e.preventDefault();
				e.stopPropagation();
			}

		});
		$('.file-upload input')[0].addEventListener('change', function (e) {
			filesAppend(e.target.files);
		});
		function filesAppend(files) {
			if (files.length > 0) {
				[...files].forEach(function (e) {
					UploadFile(e, function (file) {
						$('.file-upload__list').append(`<span class="uploaded-img"><img src="${file.src}"> <span class="uploaded-img__name">${file.name}</span></span>`)
					});
				});
			}
		}
		function UploadFile(el, cb) {
			/**
			 * Загрузак */
			cb({ src: 'img/gift.png', name: "very long file namevery long file name" });
		}
		$('.trigger-upload').on('click', function (e) {
			e.preventDefault();
			$('.file-upload').trigger('click');
		})
	}();

	/*** */





	/*f-short*/
	!function () {
		var self = $('.f-short');
		$('.f-short .f-short__send').on('click', function (e) {
			e.preventDefault();
			var inputs = $(this).parent().find('.f-short__input');
			for (var i = 0; i < inputs.length; i++) {
				if (inputs.eq(i)[0].value == '' || inputs.eq(i)[0].value == undefined) {
					inputs.eq(i).parent().find('.b-error').css({
						'display': 'block'
					});

					return false;
				}
				else {
					inputs.eq(i).parent().find('.b-error').css({
						'display': 'none'
					})
				}
			}
			console.info('Форма заполнена')


		});
	}();
	/*/f-short*/





	/*.b-arrord*/


	$('.b-arrord').each(function () {
		new Accord($(this), {
			link: '.b-arrord__title',
			content: '.b-arrord__text'
		});
	});

	
		

	['.tab-stages', '.personal-data', '.history-rate', '.ac-skill', '.sertificates'].forEach(function (el) {
		new Accord(el, {
			link: '.ac-tag-head',
			content: '.ac-tag-content',
			enableSize: 870
		})
	});
	$('.accord-satage').each(function(i,el){
		new Accord(el, {
			link: '.accord-satage__head',
			content: '.accord-satage__content',
			enableSize: 470
		});
	});

	!function () {
		var self = $('.reg-quiz');
		var points = self.find('.reg-quiz__points .item');
		var checks = self.find('.reg-check');
		var block = self.find('.el-reg-quiz');
		points.removeClass('is-active');
		block.removeClass('is-active is-next');

		var position = 0;


		block.eq(position).addClass('is-active');
		// points.eq(position).addClass('is-active');
		block.eq(position + 1).addClass('is-next');

		function next(pos) {
			var id = pos;
			points.eq(id - 1).addClass('is-active');
			block.eq(id + 1).addClass('is-next');
			var active = block.filter('.is-active');
			active.addClass('is-success');
			//console.log(active);
			setTimeout(function () {
				active.removeClass('is-active');
				block.eq(id).addClass('is-active');
				block.eq(id).removeClass('is-next');
			}, 0);
			setTimeout(function () {
				active.removeClass('is-success');
			}, 1000);
		}
		checks.on('change', function (ev) {
			next(++position)
		});
	}();
});